import React from 'react'
import Navbar from '../Components/Navbar'
import Footer from '../Components/Footer'
import bookdetails from '../Assets/workshopdown.jpg'

function Service3() {
  return (
    <>
    <Navbar/>
    <div className='aboutbanner aboutbanner9'>
    <h3>Workshops</h3>
    {/* <p>Escape, Recharge & Renew</p> */}

    </div>
    <div className='about-classes'>
    <div className='about-classes-left'>
    {/* <h3>Balance your body, calm your mind, and discover your inner strength.</h3> */}
    {/* <p>In this class, we focus on building stability, focus, and resilience—on and off the mat. Combining grounding poses, mindful breathing, and controlled transitions, this class trains your body to find strength in stillness and movement.</p> */}

    <p>Emotional support and guidance for women navigating different stages of life.</p>

    
    <ul>
    <li><b>Mama Talks </b> A warm, nurturing space where expecting mothers can connect, share experiences, and receive expert guidance to navigate pregnancy with confidence.</li>
    <li><b>Postpartum Journey </b> A safe, supportive space for mothers to share their experiences, feel understood, and receive gentle guidance through their postpartum healing journey.</li>
    <li><b>Fertility Wisdom </b> A heartfelt session where you can share your journey, release fears, and receive holistic guidance to support your conception journey.</li>
    <li><b>Relationship Healing </b> A heart-centered gathering for women seeking to explore emotions, heal past wounds, and build fulfilling, conscious relationships.</li>

       


    </ul>

    

    
</div>
   <div className='about-classes-right'>
<img src={bookdetails}/>
 

</div>
    </div>
    <Footer/>
   </>
  )
}

export default Service3